const theme = {
  colors: {
    primary: '#2563eb',
    primaryGradient: 'linear-gradient(90deg, #2563eb 0%, #3b82f6 100%)',
    secondary: '#3b82f6',
    white: '#fff',
    black: '#333',
    gray: '#555',
    overlay: 'rgba(30, 30, 30, 0.45)',
    shadow: 'rgba(37, 99, 235, 0.15)',
    error: '#2563eb',
  },
};

export default theme; 